module.exports = __webpack_public_path__ + "static/media/load.4a4a03ed.svg";